<template>
  <div>
    <template v-if="$route.name=='domainManage'">
      <div class="domainmanage">
        <div class="domainsearch" v-if="!batchMode">
          <div class="searchBox">
            <span>{{$t('label.w96')}}</span>
            <Input
              type="text"
              :placeholder="$t('pl.p18')"
              style="width:160px"
              v-model="pledgeName"
            />
            <Button type="primary" @click="filterChange">{{$t('btn.b21')}}</Button>
            <Select style="width:120px" v-model="s1" @on-change="filterChange('s1')">
              <Option :value="0">{{$t('option.w22')}}</Option>
              <Option :value="1">{{$t('option.w23')}}</Option>
              <Option :value="2">{{$t('option.w24')}}</Option>
              <Option :value="3">{{$t('option.w25')}}</Option>
              <Option :value="4">{{$t('option.w26')}}</Option>
              <Option :value="5">{{$t('option.w27')}}</Option>
              <Option :value="7">{{$t('option.w28')}}</Option>
              <Option :value="8">{{$t('option.w29')}}</Option>
            </Select>
            <Select style="width:120px" v-model="s2" @on-change="filterChange('s2')">
              <Option :value="0">{{$t('option.w30')}}</Option>
              <Option :value="6">{{$t('option.w31')}}</Option>
              <Option :value="9">{{$t('option.w32')}}</Option>
            </Select>
            <router-link :to="{name:'batchRemove'}"></router-link>
          </div>
          <div class="operateBtn">
            <span class="btn1" @click="batchMode=1">{{$t('btn.b22')}}</span>
            <span class="btn2 icon" @click="$router.push({name:'applyCredit'})">
              <i></i>
              {{$t('btn.b23')}}
            </span>
          </div>
        </div>
        <div class="batchOperation" v-if="batchMode">
          <div class="top">
            <div class="top-l">
              <span @click="batchMode=1" :class="{active:batchMode==1}">{{$t('nav.w67')}}</span>
              <span @click="batchMode=2" :class="{active:batchMode==2}">{{$t('nav.w68')}}</span>
              <span @click="batchMode=3" :class="{active:batchMode==3}">{{$t('nav.w69')}}</span>
            </div>
            <div class="top-r">
              <span @click="batchMode=0">{{$t('btn.b24')}}</span>
              <span @click="submitBatch">{{$t('btn.b5')}}</span>
            </div>
          </div>
        </div>
        <div class="domainList">
          <Datatable
            :url="dataurl"
            field="PledgeList"
            :filter="dataFilter"
            ref="Datatable"
            :colcount="7"
            :tip="tip"
          >
            <tr slot="th">
              <th>
                <Checkbox v-model="allcheck" v-if="batchMode" />
                {{$t('label.w96')}}
              </th>
              <th>{{$t('label.w160')}}</th>
              <th>{{$t('label.w119')}}</th>
              <th>{{$t('label.w187')}}</th>
              <th>{{$t('label.w188')}}</th>
              <th>{{$t('label.w189')}}</th>
              <th>{{$t('label.w19')}}</th>
            </tr>

            <template v-slot="{item}">
              <tr>
                <td>
                  <Checkbox
                    v-model="checkedList[item.Id]"
                    :disabled="!item.UserOperatorAccount&&batchMode==1"
                    v-if="batchMode"
                  />
                  <span class="text-primary">{{item.Name}}</span>
                </td>
                <td>
                  {{item.OperatorName}}
                  <span
                    class="text-warning"
                    v-if="!item.UserOperatorAccount&&batchMode==1"
                  >({{$t('option.w41')}})</span>
                </td>
                <td>{{item.CreditAmount | money}}</td>
                <td>{{item.CreditCompletedAt}}</td>
                <td>{{item.PledgeStateName}}</td>
                <td>{{item.LoanStateName}}</td>
                <td>
                  <span class="opebtn" v-if="item.State==6">
                    <a
                      href="javascript:;"
                      @click="detail(item)"
                    >{{detailId===item.Id?$t('btn.b69'):$t('btn.b70')}}</a>
                  </span>
                  <span class="opebtn" v-if="item.State==5">
                    <a href="javascript:;" @click="openModal('unpledge',item)">{{$t('btn.b71')}}</a>
                  </span>
                  <span class="opebtn" v-if="item.State==3">
                    <a href="javascript:;" @click="openModal('pledge',item)">{{$t('btn.b72')}}</a>
                  </span>
                  <span
                    class="opebtn"
                    v-if="item.State==1||item.State==2||item.State==3"
                    @click="openModal('del',item)"
                  >
                    <a href="javascript:;">{{$t('btn.b25')}}</a>
                  </span>
                </td>
              </tr>
              <tr v-if="detailId===item.Id">
                <td colspan="7" class="detailtd">
                  <div :style="{position:'relative',minHeight:'74px'}">
                    <Spin fix v-show="detailloading"></Spin>
                    <table>
                      <tr>
                        <th>{{$t('label.w153')}}</th>
                        <th>{{$t('label.w3')}}</th>
                        <th>{{$t('label.w2')}}</th>
                        <th>{{$t('label.w58')}}</th>
                        <th>{{$t('label.w189')}}</th>
                      </tr>
                      <tr v-for="v in detailList" :key="v.Id">
                        <td>
                          <router-link :to="{name:'borrowDetails',params:{id:v.Id}}">
                            <span class="text-primary">{{v.Number}}</span>
                          </router-link>
                          <!-- <span class="text-primary">{{v.Number}}</span> -->
                        </td>
                        <td>{{(v.Rate*100).toFixed(1)}}%</td>
                        <td>{{v.Amount | money}}</td>
                        <td>{{v.NextRepayAt}}</td>
                        <td>{{v.StateName}}</td>
                      </tr>
                    </table>
                  </div>
                </td>
              </tr>
            </template>
          </Datatable>
        </div>
      </div>
      <DelConfirm ref="DelConfirm" @del="del" />
      <Pledge ref="Pledge" @done="refresh" />
      <Unpledge ref="Unpledge" @done="refresh" />
    </template>
    <router-view v-else />
  </div>
</template>

<script>
import Datatable from "@/components/datatable";
import DelConfirm from "@/components/delConfirm";
import Pledge from "./modal/pledge";
import Unpledge from "./modal/unpledge";
export default {
  components: { Datatable, DelConfirm, Pledge, Unpledge },
  data() {
    return {
      dataurl: "/Member/RZJPledge/PledgeList",
      batchMode: 0, // 0-非批量操作 1-批量解除 2-批量删除 3-批量质押
      dataFilter: {},
      pledgeName: "",
      s1: 0,
      s2: 0,
      detailId: "",
      detailList: [],
      detailloading: false,
      allcheck: false,
      checkedList: {}
    };
  },
  computed: {
    tip() {
      if (this.batchMode == 0) {
        return this.$t("msg.m105");
      }
      if (this.batchMode == 1) {
        return this.$t("msg.m106");
      }
      if (this.batchMode == 2) {
        return this.$t("msg.m107");
      }
      if (this.batchMode == 3) {
        return this.$t("msg.m108");
      }
    }
  },
  watch: {
    $route() {
      this.batchMode = 0;
    },
    allcheck(v) {
      this.$refs.Datatable.datalist.forEach(vv => {
        if (!vv.UserOperatorAccount && this.batchMode == 1) return;
        this.checkedList[vv.Id] = v;
      });
    },
    batchMode(v) {
      this.allcheck = false;
      this.checkedList = {};
      if (v) {
        this.dataurl = "/Member/RZJPledge/BatchPledgeList";
        this.dataFilter = {
          type: v
        };
      } else {
        this.dataurl = "/Member/RZJPledge/PledgeList";
        this.dataFilter = {};
      }
    }
  },
  methods: {
    filterChange(t) {
      let v = {};
      v.pledgeName = this.pledgeName;
      if (t == "s1" && this.s1) {
        this.s2 = 0;
        v.pledgeStateQuery = this.s1;
      } else if (t == "s2" && this.s2) {
        this.s1 = 0;
        v.pledgeStateQuery = this.s2;
      }
      this.dataFilter = v;
    },
    detail(v) {
      if (this.detailloading) return;
      if (this.detailId == v.Id) return (this.detailId = "");
      this.detailId = v.Id;
      this.detailloading = true;
      this.detailList = [];
      this.$axios
        .get("/Member/RZJPledge/PledgeLoanScheme?pledgeId=" + v.Id)
        .then(res => {
          console.log(res);
          this.detailloading = false;
          if (!res.err) {
            this.detailList = res;
          }
        });
    },
    refresh() {
      this.$refs.Datatable.refresh();
    },
    openModal(n, v) {
      switch (n) {
        case "del":
          this.$refs.DelConfirm.text = `${this.$t("msg.m56")}“${v.Name}”？`;
          this.$refs.DelConfirm.id = v.Id;
          this.$refs.DelConfirm.modal = true;
          break;
        case "pledge":
          this.$refs.Pledge.info = v;
          this.$refs.Pledge.modal = true;
          break;
        case "unpledge":
          if (v.IsBindOperator) {
            this.$refs.Unpledge.info = v;
            this.$refs.Unpledge.modal = true;
          } else {
            this.$Message.error({
              content: `${this.$t("msg.m57")}${v.OperatorName}${this.$t(
                "msg.m58"
              )}`,
              duration: 4
            });
            this.$router.push({ name: "registrarManage" });
          }
          break;
      }
    },
    async del(id) {
      let res;
      if (typeof id === "string") {
        res = await this.$axios.post("/Member/RZJPledge/DeletePledge", {
          pledgeId: id
        });
      } else {
        res = await this.$axios.post("/Member/RZJPledge/BatchDeletePledge", {
          pledgeIds: id.join(",")
        });
      }

      res.throw();
      if (res.err) return;
      this.refresh();
      this.checkedList = {};
      this.allcheck = false;
    },
    submitBatch() {
      let ids = [];
      for (let n in this.checkedList) {
        if (this.checkedList[n]) ids.push(n);
      }
      if (!ids.length) return this.$Message.error(this.$t("msg.m59"));

      if (this.batchMode == 1) {
        // 批量解除质押
        this.$router.push({
          name: "batchRemove",
          params: { ids: ids.join(",") }
        });
      } else if (this.batchMode == 2) {
        // 批量删除
        this.$refs.DelConfirm.text = `${this.$t("msg.m60")}(${this.$t(
          "msg.m87"
        ).replace("{%}", ids.length)})？`;
        this.$refs.DelConfirm.id = ids;
        this.$refs.DelConfirm.modal = true;
      } else if (this.batchMode == 3) {
        // 批量质押
        this.$router.push({
          name: "batchPledge",
          params: { ids: ids.join(",") }
        });
      }
    }
  }
};
</script>


<style lang="less" scoped>
.domainmanage {
  margin-top: 30px;
  min-height: 600px;
  .domainsearch {
    display: flex;
    justify-content: space-between;
    .searchBox {
      span {
        margin-right: 10px;
      }
      .ivu-input-wrapper {
        margin-right: 10px;
        /deep/.ivu-input {
          background: #fff;
          color: #b3b3b6;
        }
      }
      .ivu-btn {
        margin-right: 60px;
        background: #5e8ffc;
        width: 80px;
      }
      .ivu-select {
        margin-right: 10px;
        /deep/.ivu-select-selection {
          background: rgba(255, 255, 255, 1);
          border-radius: 8px;
        }
      }
    }
    .operateBtn {
      span {
        display: inline-block;
        cursor: pointer;
        width: 101px;
        height: 40px;
        text-align: center;
        border-radius: 8px;
        border: 1px solid rgba(151, 151, 151, 1);
        font-size: 14px;
        font-weight: 500;
        line-height: 40px;
      }
      .icon {
        background: #5e8ffc;
        border-color: #5e8ffc;
        color: #fff;
        margin-left: 20px;
        i {
          width: 14px;
          height: 17px;
          margin-right: 4px;
          display: inline-block;
          vertical-align: middle;
          background: url("../../assets/assetcenter/dumian_apply.png") no-repeat;
          background-size: cover;
        }
      }
    }
  }
  .domainList {
    margin-top: 30px;
  }
}
.batchOperation {
  .top {
    display: flex;
    justify-content: space-between;
    .top-l {
      span {
        cursor: pointer;
        display: inline-block;
        width: 100px;
        height: 40px;
        margin-right: 10px;
        border-radius: 8px;
        line-height: 40px;
        color: #7b7b7c;
        font-weight: 500;
        font-size: 14px;
        text-align: center;
      }
      .active {
        background: rgba(94, 143, 252, 1);
        color: #fff;
      }
    }
    .top-r {
      span {
        display: inline-block;
        cursor: pointer;
        width: 130px;
        height: 40px;
        border: 1px solid rgba(151, 151, 151, 1);
        border-radius: 8px;
        line-height: 40px;
        color: #7b7b7c;
        font-weight: 500;
        font-size: 14px;
        text-align: center;
      }
      span:last-child {
        margin-left: 20px;
        width: 72px;
        color: #fff;
        background: #5e8ffc;
        border-color: #5e8ffc;
      }
    }
  }
}
.detailtd {
  padding: 0 !important;
  background: rgba(233, 234, 238, 1);
  line-height: 20px;
  box-shadow: inset 0px 30px 15px -20px rgba(0, 0, 0, 0.1);
  tbody {
    background: none !important;
  }
  tr {
    border-color: #dbdce0;
    &:last-child {
      border-bottom: 0;
    }
  }
  td,
  th {
    padding: 8px;
    &:first-child {
      text-align: left;
      padding-left: 30px;
    }
  }
  th {
    font-size: 12px;
    color: #7b7b7c;
    font-weight: normal;
  }
}
.opebtn {
  &:before {
    content: "|";
    margin: 0 8px;
    color: #ccc;
  }
  &:first-child {
    &:before {
      display: none;
    }
  }
}
</style>
